const lessons = [
  "Fresh, healthy food remains unaffordable in many remote communities.",
  "Remote communities remain highly vulnerable to supply disruption.",
  "Community gardens succeed when ongoing support exists.",
  "Schools, Elders and ranger programs become powerful partners.",
  "Local participation grows when communities shape the system themselves.",
  "Practical training and long-term support matter more than one-off infrastructure.",
];

export default function WhatWeHaveLearned() {
  return (
    <section
      id="learned"
      data-testid="learned-section"
      className="relative bg-sand py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-5 md:sticky md:top-28">
            <div className="text-xs uppercase tracking-[0.3em] text-rust mb-6">
              Ground Truth
            </div>
            <h2
              data-testid="learned-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-charcoal"
            >
              What we have
              <span className="block italic text-rust">learned.</span>
            </h2>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-ink max-w-md">
              Years of working alongside remote communities have demonstrated
              several consistent realities. Growing Country has been designed
              around these lessons.
            </p>
          </div>

          <div className="md:col-span-7 md:col-start-6">
            <ol className="space-y-px bg-stone-line border border-stone-line">
              {lessons.map((lesson, i) => (
                <li
                  key={i}
                  data-testid={`lesson-${i}`}
                  className="bg-sand p-6 md:p-8 flex items-start gap-6 group hover:bg-stone-alt transition-colors"
                >
                  <span className="font-serif text-3xl md:text-4xl text-rust tick-num leading-none shrink-0 w-12">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="font-serif text-xl md:text-2xl text-charcoal leading-snug pt-1">
                    {lesson}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
